import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTableModule } from '@angular/cdk/table';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AdminSubMenuComponent } from './admin/admin-menu-component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashHealthCountsComponent } from './dashboard/dash-health-counts.component';
import { DashIssueComponent } from './dashboard/dash-issue.component';
import { DashVersionComponent } from './dashboard/dash-version.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FirmwareEditComponent } from './firmware/firmware-edit.component';
import { FirmwareRouteEditComponent } from './firmware/firmware-route-edit.component';
import { FirmwareSetComponent } from './firmware/firmware-set.component';
import { FirmwareSetsComponent } from './firmware/firmware-sets.component';
import { FirmwaresComponent } from './firmware/firmwares.component';
import { FirmwarePayloadComponent } from './hub-details/checkfirmwareversion-payload.component';
import { FuelFillEditComponent } from './hub-details/fuel-fill-edit.component';
import { GetHubsPayloadComponent } from './hub-details/gethubs-payload.component';
import { GrafanaLinkComponent } from './hub-details/grafana-link.component';
import { GrafanaOilLinkComponent } from './hub-details/grafana-oil-link.component';
import { HistoryPayloadComponent } from './hub-details/history-payload.component';
import { HubActionsComponent } from './hub-details/hub-actions.component';
import { HubDetailComponent } from './hub-details/hub-detail.component';
import { HubGraphComponent } from './hub-details/hub-graph.component';
import { HubInformationComponent } from './hub-details/hub-information.component';
import { HubInstallationComponent } from './hub-details/hub-installation.component';
import { HubSubMenuComponent } from './hub-details/hub-menu-component';
import { HubMessagesComponent } from './hub-details/hub-messages.component';
import { HubOilDetailsComponent } from './hub-details/hub-oil-details.component';
import { HubPairingsComponent } from './hub-details/hub-pairings.component';
import { HubScheduleComponent } from './hub-details/hub-schedule.component';
import { HubSpendChartComponent } from './hub-details/hub-spend-chart.component';
import { HubSpendComponent } from './hub-details/hub-spend.component';
import { HubStateComponent } from './hub-details/hub-state.component';
import { HubCommsComponent } from './hub-details/hubcomms.component';
import { HubHealthComponent } from './hub-details/hubhealth.component';
import { MeterReadingsComponent } from './hub-details/meter-readings.component';
import { SchedulePayloadComponent } from './hub-details/schedule-payload.component';
import { SnapshotPayloadComponent } from './hub-details/snapshot-payload.component';
import { ExpandedIssueComponent } from './issues/expanded-issue.component';
import { HubIssuesComponent } from './issues/hubissues.component';
import { IssueActionsComponent } from './issues/issue-actions.component';
import { IssueStatsComponent } from './issues/issue-stats.component';
import { NewIssueComponent } from './issues/new-issue.component';
import { DashComponent } from './mastersheet/dash.component';
import { ECSMHeaderComponent } from './mastersheet/ecms/ecms-header.component';
import { ECMSTableComponent } from './mastersheet/ecms/ecms-table.component';
import { RemoveECMSComponent } from './mastersheet/ecms/remove-ecms.component';
import { UploadECMSComponent } from './mastersheet/ecms/upload-ecms.component';
import { ReportsHeaderComponent } from './mastersheet/geopal/reports-header.component';
import { ReportsComponent } from './mastersheet/geopal/reports.component';
import { NewLeadsAddComponent } from './mastersheet/leads/newleads-add.component';
import { NewLeadsHeaderComponent } from './mastersheet/leads/newleads-header.component';
import { NewLeadsTableComponent } from './mastersheet/leads/newleads-table.component';
import { NewLeadsUpdateComponent } from './mastersheet/leads/newleads-update.component';
import { MasterHeaderComponent } from './mastersheet/mastersheet/master-header.component';
import { MasterSheetTableComponent } from './mastersheet/mastersheet/mastersheet-table.component';
import { MastersheetUploadComponent } from './mastersheet/mastersheet/mastersheet-update.component';
import { UploadFileComponent } from './mastersheet/upload-file.component';
import { MenuComponent } from './menu/menu.component';
import { SubmenuComponent } from './menu/submenu.component';
import { MessagesComponent } from './message/messages.component';
import { NewMessageComponent } from './message/new-message.component';
import { AllIssuesComponent } from './misc/all-issues.component';
import { AllMastersheetComponent } from './misc/all-mastersheet.component';
import { AllMessagesComponent } from './misc/all-messages.component';
import { AllMetersComponent } from './misc/all-meters.component';
import { AllStockComponent } from './misc/all-stock.component';
import { CustomerTypesComponent } from './misc/customer-types.component';
import { GlitchesComponent } from './misc/glitches.component';
import { HubSearchComponent } from './misc/hub-search.component';
import { HubsSubMenuComponent } from './misc/hubs-menu-component';
import { HubsComponent } from './misc/hubs.component';
import { InstallationComponent } from './misc/installation.component';
import { NewMessagePageComponent } from './misc/new-message-page.component';
import { NewHubsComponent } from './misc/newhubs.component';
import { OneHubRowComponent } from './misc/one-hub.component';
import { ProblemsComponent } from './misc/problems.component';
import { RebootsComponent } from './misc/reboots.component';
import { WiresChangedHubsComponent } from './misc/wires-changed-hubs.component';
import { BooleanPipe } from './pipes/boolean.pipe';
import { CommsTypePipe } from './pipes/comms-type';
import { DegreesPipe } from './pipes/degrees.pipe';
import { GoDatePipe } from './pipes/godate.pipe';
import { HeatingStatePipe } from './pipes/heating-state';
import { HumanIntervalPipe } from './pipes/human-interval.pipe';
import { UnixDatePipe } from './pipes/unixdate.pipe';
import { VersionPipe } from './pipes/version.pipe';
import { ProfileDetailComponent } from './profiles/profile-detail.component';
import { ProfilesComponent } from './profiles/profiles.component';
import { QueriesComponent } from './queries/queries.component';
import { ApiService } from './services/api.service';
import { HubService } from './services/hub.service';
import { ProfileService } from './services/profile.service';
import { InstallationCategoryComponent } from './stock/installation-category.component';
import { InstallationsComponent } from './stock/installations.component';
import { ModStockComponent } from './stock/modify-stock.component';
import { OneInstallationRowComponent } from './stock/one-install.component';
import { InstallUploadComponent } from './stock/stock-install-upload.component';
import { StockSubMenuComponent } from './stock/stock-menu-component';
import { StockSummaryComponent } from './stock/stock-summary.component';
import { HubStockComponent } from './stock/stock.component';

@NgModule({
  imports: [
    BrowserModule,  // This should always be first
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatCheckboxModule,
    MatInputModule,
    MatGridListModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    CdkTableModule,
    MatTableModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    FlexLayoutModule,
    ScrollingModule,
    MatDialogModule,
  ],
  declarations: [
    AppComponent,
    MenuComponent,
    DashboardComponent,
    DashVersionComponent,
    DashIssueComponent,
    IssueStatsComponent,
    DashHealthCountsComponent,
    HubSubMenuComponent,
    HubsSubMenuComponent,
    HubsComponent,
    OneHubRowComponent,
    NewHubsComponent,
    ProblemsComponent,
    HubDetailComponent,
    HubActionsComponent,
    HubInformationComponent,
    HubStateComponent,
    HubSearchComponent,
    HubHealthComponent,
    HubIssuesComponent,
    HubScheduleComponent,
    HubGraphComponent,
    NewMessageComponent,
    HubMessagesComponent,
    AllMessagesComponent,
    MessagesComponent,
    NewMessagePageComponent,
    InstallationComponent,
    HubInstallationComponent,
    HubPairingsComponent,
    ExpandedIssueComponent,
    IssueActionsComponent,
    AllStockComponent,
    AllMastersheetComponent,
    HubStockComponent,
    HubSpendComponent,
    StockSummaryComponent,
    StockSubMenuComponent,
    ModStockComponent,
    DashComponent,
    RemoveECMSComponent,
    MasterSheetTableComponent,
    ECMSTableComponent,
    ReportsComponent,
    ReportsHeaderComponent,
    MasterHeaderComponent,
    ECSMHeaderComponent,
    InstallUploadComponent,
    InstallationsComponent,
    InstallationCategoryComponent,
    OneInstallationRowComponent,
    HubCommsComponent,
    CustomerTypesComponent,
    MeterReadingsComponent,
    AllMetersComponent,
    AllIssuesComponent,
    NewIssueComponent,
    RebootsComponent,
    FirmwareSetsComponent,
    FirmwaresComponent,
    SchedulePayloadComponent,
    SnapshotPayloadComponent,
    GetHubsPayloadComponent,
    FirmwarePayloadComponent,
    FirmwareEditComponent,
    FirmwareRouteEditComponent,
    FirmwareSetComponent,
    WiresChangedHubsComponent,
    SubmenuComponent,
    HistoryPayloadComponent,
    GlitchesComponent,
    ProfilesComponent,
    ProfileDetailComponent,
    BooleanPipe,
    DegreesPipe,
    GoDatePipe,
    VersionPipe,
    HumanIntervalPipe,
    CommsTypePipe,
    HeatingStatePipe,
    UnixDatePipe,
    GrafanaLinkComponent,
    AdminSubMenuComponent,
    QueriesComponent,
    HubSpendChartComponent,
    HubOilDetailsComponent,
    FuelFillEditComponent,
    GrafanaOilLinkComponent,
    UploadECMSComponent,
    MastersheetUploadComponent,
    UploadFileComponent,
    NewLeadsHeaderComponent,
    NewLeadsTableComponent,
    NewLeadsAddComponent,
    NewLeadsUpdateComponent,
  ],
  providers: [
    ApiService,
    HubService,
    MatDatepickerModule,
    ProfileService],
  bootstrap: [AppComponent],
})


export class AppModule {
}
